import i18n from 'i18n';

import { IRule } from './types';

export class NotUpperCase implements IRule {

	passes(value: string): boolean {
		if (!value || /\d/.test(value)) return true;
		return value !== value.toUpperCase();
	}

	message(): string {
		return i18n.t('validation:notUpperCase');
	}
}
